/* @flow */

import PropTypes from "prop-types";

import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";

/**
 * Creates a DropDown to change the visibility of a personal list.
 *
 * This component can be invisible for lists that are per default only visible
 * in store context (showGloballyVisibleChanger)
 *
 * This component can be visbible but the changing of the visibility might be
 * disabled for lists that are globally visible but accessed from another
 * store (isGloballyVisibleChangerActive)
 *
 */
class ListVisibilityChanger extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        initialValue: PropTypes.bool,
        showGloballyVisibleChanger: PropTypes.bool,
        isGloballyVisibleChangerActive: PropTypes.bool,
        changeVisibility: PropTypes.func
    };

    static contextTypes = {
        intl: PropTypes.object
    };

    render() {
        if (this.props.showGloballyVisibleChanger) {
            return (
                <div>
                    <ControlLabel>
                        {" "}
                        {this.context.intl.formatMessage({ id: "PERSONAL_LIST_VISIBILITY_HEADLINE" })}
                    </ControlLabel>
                    <FormControl
                        value={this.props.initialValue === false ? "storeVisible" : "globallyVisible"}
                        disabled={!this.props.isGloballyVisibleChangerActive}
                        onChange={this.props.changeVisibility}
                        componentClass="select"
                        placeholder="select">
                        <option value="globallyVisible">
                            {this.context.intl.formatMessage({ id: "PERSONAL_LIST_GLOBAL_VISIBILITY" })}
                        </option>
                        <option value="storeVisible">
                            {this.context.intl.formatMessage({ id: "PERSONAL_LIST_RESTRICTED_VISIBILITY" })}
                        </option>
                    </FormControl>
                </div>
            );
        }
        return <div />;
    }
}

export default ListVisibilityChanger;
